import {
    CLOSE_EDIT_META_SECTION_POPUP,
    CLOSE_EDIT_TEXT_SECTION_POPUP,
    DELETE_SECTION_IN_PAGE_STATE,
    FETCHED_ELEMENTS,
    GET_PAGE,
    ADD_API_CALL_IN_PROGRESS,
    REMOVE_API_CALL_IN_PROGRESS,
    SAVED_PAGE,
    MOVE_SECTION,
    NEW_SECTION,
    OPEN_EDIT_META_SECTION_POPUP,
    OPEN_EDIT_TEXT_SECTION_POPUP,
    DONE_EDIT_TEXT_SECTION_POPUP,
    OPEN_EDIT_TEXT_SECTION_COLUMNS_SINGLE_MEDIA_POPUP,
    CLOSE_EDIT_TEXT_SECTION_COLUMNS_SINGLE_MEDIA_POPUP,
    DONE_EDIT_TEXT_SECTION_COLUMNS_SINGLE_MEDIA_POPUP,
    CLOSE_EDIT_MAP_SECTION_POPUP,
    DONE_EDIT_MAP_SECTION_POPUP,
    OPEN_EDIT_MAP_SECTION_POPUP,
    DONE_EDIT_META_SECTION_POPUP,
    OPEN_EDIT_STAFF_SECTION_POPUP,
    CLOSE_EDIT_STAFF_SECTION_POPUP,
    DONE_EDIT_STAFF_SECTION_POPUP,
    OPEN_EDIT_BLOCK_SECTION_POPUP,
    DONE_EDIT_BLOCK_SECTION_POPUP,
    CLOSE_EDIT_BLOCK_SECTION_POPUP,
    DISABLE_SECTION_IN_PAGE_STATE,
    ENABLE_SECTION_IN_PAGE_STATE,
    OPEN_EDIT_PARTNERS_SECTION_POPUP,
    CLOSE_EDIT_PARTNERS_SECTION_POPUP,
    DONE_EDIT_PARTNERS_SECTION_POPUP,
    OPEN_EDIT_OVERVIEW_SECTION_POPUP,
    CLOSE_EDIT_OVERVIEW_SECTION_POPUP,
    DONE_EDIT_OVERVIEW_SECTION_POPUP,
    UPDATE_SECTION_GROUP_IN_PAGE_STATE,
    PICK_PARENT_PAGE,
    OPEN_EDIT_REVIEWS_SECTION_POPUP,
    OPEN_EDIT_ITINERARY_SECTION_POPUP,
    CLOSE_EDIT_REVIEWS_SECTION_POPUP,
    CLOSE_EDIT_ITINERARY_SECTION_POPUP,
    DONE_EDIT_REVIEWS_SECTION_POPUP,
    DONE_EDIT_ITINERARY_SECTION_POPUP,
    DONE_EDIT_URL_POPUP,
    INVALIDATE_URL_IN_THE_URL_EDIT_POPUP,
    UPDATE_NEW_URL_IN_THE_URL_EDIT_POPUP,
    UPDATE_NO_INDEX_IN_THE_URL_EDIT_POPUP,
    CLOSE_URL_EDIT_POPUP,
    OPEN_URL_EDIT_POPUP,
    OPEN_EDIT_FORM_SECTION_POPUP,
    CLOSE_EDIT_FORM_SECTION_POPUP,
    DONE_EDIT_FORM_SECTION_POPUP,
    FETCHED_FORM_TYPES,
    OPEN_EDIT_TRIP_FORMATS_SECTION_POPUP,
    CLOSE_EDIT_TRIP_FORMATS_SECTION_POPUP,
    DONE_EDIT_TRIP_FORMATS_SECTION_POPUP,
    OPEN_EDIT_PRODUCT_SNIPPETS_SECTION_POPUP,
    CLOSE_EDIT_PRODUCT_SNIPPETS_SECTION_POPUP,
    DONE_EDIT_PRODUCT_SNIPPETS_SECTION_POPUP,
    OPEN_EDIT_INTERNAL_LINKS_SECTION_POPUP,
    CLOSE_EDIT_INTERNAL_LINKS_SECTION_POPUP,
    DONE_EDIT_INTERNAL_LINKS_SECTION_POPUP,
    OPEN_EDIT_CALL_TO_ACTION_SECTION_POPUP,
    CLOSE_EDIT_CALL_TO_ACTION_SECTION_POPUP,
    DONE_EDIT_CALL_TO_ACTION_SECTION_POPUP,
    OPEN_EDIT_NEXT_STEPS_SECTION_POPUP,
    CLOSE_EDIT_NEXT_STEPS_SECTION_POPUP,
    DONE_EDIT_NEXT_STEPS_SECTION_POPUP,
    OPEN_EDIT_REVIEW_SNIPPETS_SECTION_POPUP,
    CLOSE_EDIT_REVIEW_SNIPPETS_SECTION_POPUP,
    DONE_EDIT_REVIEW_SNIPPETS_SECTION_POPUP,
    OPEN_EDIT_FAQS_SECTION_POPUP,
    CLOSE_EDIT_FAQS_SECTION_POPUP,
    DONE_EDIT_FAQS_SECTION_POPUP,
    OPEN_EDIT_FIND_YOUR_PROJECT_SECTION_POPUP,
    CLOSE_EDIT_FIND_YOUR_PROJECT_SECTION_POPUP,
    DONE_EDIT_FIND_YOUR_PROJECT_SECTION_POPUP,
    OPEN_EDIT_LARGE_SNIPPETS_SECTION_POPUP,
    CLOSE_EDIT_LARGE_SNIPPETS_SECTION_POPUP,
    DONE_EDIT_LARGE_SNIPPETS_SECTION_POPUP,
    OPEN_EDIT_VALUE_PROPOSITION_SECTION_POPUP,
    CLOSE_EDIT_VALUE_PROPOSITION_SECTION_POPUP,
    DONE_EDIT_VALUE_PROPOSITION_SECTION_POPUP,
    OPEN_EDIT_MEET_US_SECTION_POPUP,
    CLOSE_EDIT_MEET_US_SECTION_POPUP,
    DONE_EDIT_MEET_US_SECTION_POPUP,
    OPEN_EDIT_TRIP_FORMATS_CAROUSEL_SECTION_POPUP,
    CLOSE_EDIT_TRIP_FORMATS_CAROUSEL_SECTION_POPUP,
    DONE_EDIT_TRIP_FORMATS_CAROUSEL_SECTION_POPUP,
    OPEN_EDIT_GROUP_TRIPS_BANNER_SECTION_POPUP,
    CLOSE_EDIT_GROUP_TRIPS_BANNER_SECTION_POPUP,
    DONE_EDIT_GROUP_TRIPS_BANNER_SECTION_POPUP,
    FETCHED_PAGE_VERSIONS,
    FETCHED_PAGE_VERSION,
    DELETED_PAGE_VERSION,
    UPDATED_PAGE_VERSION,
    OPEN_VIEW_PAGE_VERSION_POPUP,
    CLOSE_VIEW_PAGE_VERSION_POPUP,
    OPEN_PRODUCT_TAGOS_ID_EDIT_POPUP,
    UPDATE_PRODUCT_TAGOS_ID_EDIT_POPUP,
    CLOSE_PRODUCT_TAGOS_ID_EDIT_POPUP,
    DONE_EDIT_PRODUCT_TAGOS_ID_POPUP,
    OPEN_PAGE_TAGS_EDIT_POPUP,
    UPDATE_PAGE_TAGS_EDIT_POPUP,
    CLOSE_PAGE_TAGS_EDIT_POPUP,
    DONE_EDIT_PAGE_TAGS_POPUP,
    DISCARD_CHANGES,
    SET_PAGE_PREVIEW,
    HAS_ERROR,
    UPDATE_MULTIPLE_PAGE_TAGS,
    OPEN_PAGE_PICKER,
    CLOSE_PAGE_PICKER,
    CHANGE_SECTION_BG_COLOR,
    SET_BG_COLORS,
    UPDATE_SECTION,
    TOGGLE_SECTION_POPUP,
} from './types';

import {
    OPEN_EDIT_PROMOTIONAL_BOXES_SECTION_POPUP,
    CLOSE_EDIT_PROMOTIONAL_BOXES_SECTION_POPUP,
    DONE_EDIT_PROMOTIONAL_BOXES_SECTION_POPUP,
} from './types/promotional_boxes_types';

export function gotPage(response) {
    return {
        type: GET_PAGE,
        payload: response,
    };
}

export function addApiCallInProgress(url) {
    return {
        type: ADD_API_CALL_IN_PROGRESS,
        payload: url,
    };
}

export function removeApiCallInProgress(url) {
    return {
        type: REMOVE_API_CALL_IN_PROGRESS,
        payload: url,
    };
}

export function hasError(field, metaError) {
    return {
        type: HAS_ERROR,
        payload: {
            field: field,
            metaError: metaError,
        },
    };
}

export function discardChanges() {
    return {
        type: DISCARD_CHANGES,
    };
}

export function addedNewSection(pageId, sectionTypeId, sectionType, dropWhere) {
    return {
        type: NEW_SECTION,
        payload: {
            pageId: pageId,
            sectionTypeId: sectionTypeId,
            sectionType: sectionType,
            dropWhere: dropWhere,
        },
    };
}

export function addNewSection(pageId, sectionTypeId, sectionType, dropWhere) {
    return dispatch => {
        dispatch(
            addedNewSection(pageId, sectionTypeId, sectionType, dropWhere)
        );
    };
}

export function moveSection(pageId, dragIndex, hoverIndex, dragCard) {
    return {
        type: MOVE_SECTION,
        payload: {
            pageId: pageId,
            dragIndex: dragIndex,
            hoverIndex: hoverIndex,
            dragCard: dragCard,
        },
    };
}

export function updatedPage(id, data) {
    return {
        type: SAVED_PAGE,
        payload: {
            pageId: id,
            data: data,
        },
    };
}

export function fetchedElements(response) {
    return {
        type: FETCHED_ELEMENTS,
        payload: {
            elements: response,
        },
    };
}

export function openEditMapSection() {
    return {
        type: OPEN_EDIT_MAP_SECTION_POPUP,
    };
}

export function openEditTextSection() {
    return {
        type: OPEN_EDIT_TEXT_SECTION_POPUP,
    };
}

export function openEditTextSectionColumnsSingleMedia() {
    return {
        type: OPEN_EDIT_TEXT_SECTION_COLUMNS_SINGLE_MEDIA_POPUP,
    };
}

export function openEditOverviewSection() {
    return {
        type: OPEN_EDIT_OVERVIEW_SECTION_POPUP,
    };
}

export function openEditPartnersSection() {
    return {
        type: OPEN_EDIT_PARTNERS_SECTION_POPUP,
    };
}

export function openEditStaffSection() {
    return {
        type: OPEN_EDIT_STAFF_SECTION_POPUP,
    };
}

export function openEditReviewsSection() {
    return {
        type: OPEN_EDIT_REVIEWS_SECTION_POPUP,
    };
}

export function openEditItinerarySection() {
    return {
        type: OPEN_EDIT_ITINERARY_SECTION_POPUP,
    };
}

export function openEditBlockSection() {
    return {
        type: OPEN_EDIT_BLOCK_SECTION_POPUP,
    };
}

export function openMetaPageSection() {
    return {
        type: OPEN_EDIT_META_SECTION_POPUP,
    };
}

export function openEditFormSection() {
    return {
        type: OPEN_EDIT_FORM_SECTION_POPUP,
    };
}

export function openEditTripFormatsSection() {
    return {
        type: OPEN_EDIT_TRIP_FORMATS_SECTION_POPUP,
    };
}

export function openEditProductSnippetsSection() {
    return {
        type: OPEN_EDIT_PRODUCT_SNIPPETS_SECTION_POPUP,
    };
}

export function openEditInternalLinksSection() {
    return {
        type: OPEN_EDIT_INTERNAL_LINKS_SECTION_POPUP,
    };
}

export function openEditCallToActionSection() {
    return {
        type: OPEN_EDIT_CALL_TO_ACTION_SECTION_POPUP,
    };
}

export function openEditNextStepsSection() {
    return {
        type: OPEN_EDIT_NEXT_STEPS_SECTION_POPUP,
    };
}

export function openEditReviewSnippetsSection() {
    return {
        type: OPEN_EDIT_REVIEW_SNIPPETS_SECTION_POPUP,
    };
}

export function openEditFaqsSection() {
    return {
        type: OPEN_EDIT_FAQS_SECTION_POPUP,
    };
}

export function openEditFindYourProjectSection() {
    return {
        type: OPEN_EDIT_FIND_YOUR_PROJECT_SECTION_POPUP,
    };
}

export function openEditLargeSnippetsSection() {
    return {
        type: OPEN_EDIT_LARGE_SNIPPETS_SECTION_POPUP,
    };
}

export function openEditValuePropositionSection() {
    return {
        type: OPEN_EDIT_VALUE_PROPOSITION_SECTION_POPUP,
    };
}

export function openEditMeetUsSection() {
    return {
        type: OPEN_EDIT_MEET_US_SECTION_POPUP,
    };
}

export function openEditTripFormatsCarouselSection() {
    return {
        type: OPEN_EDIT_TRIP_FORMATS_CAROUSEL_SECTION_POPUP,
    };
}

export function openEditGroupTripsBannerSection() {
    return {
        type: OPEN_EDIT_GROUP_TRIPS_BANNER_SECTION_POPUP,
    };
}

export function openViewPageVersionPopup(pageId) {
    return {
        type: OPEN_VIEW_PAGE_VERSION_POPUP,
        payload: {
            pageId,
        },
    };
}

export function openEditPromotionalBoxesSection() {
    return {
        type: OPEN_EDIT_PROMOTIONAL_BOXES_SECTION_POPUP,
    };
}

export function closeViewPageVersionPopup() {
    return {
        type: CLOSE_VIEW_PAGE_VERSION_POPUP,
    };
}

export function closeOverviewSectionPopup() {
    return {
        type: CLOSE_EDIT_OVERVIEW_SECTION_POPUP,
    };
}

export function closeReviewsSectionPopup() {
    return {
        type: CLOSE_EDIT_REVIEWS_SECTION_POPUP,
    };
}

export function closeItinerarySectionPopup() {
    return {
        type: CLOSE_EDIT_ITINERARY_SECTION_POPUP,
    };
}

export function closeEditTextSection() {
    return {
        type: CLOSE_EDIT_TEXT_SECTION_POPUP,
    };
}

export function closeEditTextSectionColumnsSingleMedia() {
    return {
        type: CLOSE_EDIT_TEXT_SECTION_COLUMNS_SINGLE_MEDIA_POPUP,
    };
}

export function closeMetaSection() {
    return {
        type: CLOSE_EDIT_META_SECTION_POPUP,
    };
}

export function closeMapSectionPopup() {
    return {
        type: CLOSE_EDIT_MAP_SECTION_POPUP,
    };
}

export function closeStaffSectionPopup() {
    return {
        type: CLOSE_EDIT_STAFF_SECTION_POPUP,
    };
}

export function closeBlockSectionPopup() {
    return {
        type: CLOSE_EDIT_BLOCK_SECTION_POPUP,
    };
}

export function closePartnersSectionPopup() {
    return {
        type: CLOSE_EDIT_PARTNERS_SECTION_POPUP,
    };
}

export function closeFormSectionPopup() {
    return {
        type: CLOSE_EDIT_FORM_SECTION_POPUP,
    };
}

export function closeTripFormatsSectionPopup() {
    return {
        type: CLOSE_EDIT_TRIP_FORMATS_SECTION_POPUP,
    };
}

export function closeProductSnippetsSectionPopup() {
    return {
        type: CLOSE_EDIT_PRODUCT_SNIPPETS_SECTION_POPUP,
    };
}

export function closeInternalLinksSectionPopup() {
    return {
        type: CLOSE_EDIT_INTERNAL_LINKS_SECTION_POPUP,
    };
}

export function closeCallToActionSectionPopup() {
    return {
        type: CLOSE_EDIT_CALL_TO_ACTION_SECTION_POPUP,
    };
}

export function closeNextStepsSectionPopup() {
    return {
        type: CLOSE_EDIT_NEXT_STEPS_SECTION_POPUP,
    };
}

export function closeReviewSnippetsSectionPopup() {
    return {
        type: CLOSE_EDIT_REVIEW_SNIPPETS_SECTION_POPUP,
    };
}

export function closeFaqsSectionPopup() {
    return {
        type: CLOSE_EDIT_FAQS_SECTION_POPUP,
    };
}

export function closeFindYourProjectPopup() {
    return {
        type: CLOSE_EDIT_FIND_YOUR_PROJECT_SECTION_POPUP,
    };
}

export function closeLargeSnippetsPopup() {
    return {
        type: CLOSE_EDIT_LARGE_SNIPPETS_SECTION_POPUP,
    };
}

export function closeValuePropositionPopup() {
    return {
        type: CLOSE_EDIT_VALUE_PROPOSITION_SECTION_POPUP,
    };
}

export function closeMeetUsPopup() {
    return {
        type: CLOSE_EDIT_MEET_US_SECTION_POPUP,
    };
}

export function closeTripFormatsCarouselPopup() {
    return {
        type: CLOSE_EDIT_TRIP_FORMATS_CAROUSEL_SECTION_POPUP,
    };
}

export function closeGroupTripsBannerPopup() {
    return {
        type: CLOSE_EDIT_GROUP_TRIPS_BANNER_SECTION_POPUP,
    };
}

export function closePromotionalBoxesPopup() {
    return {
        type: CLOSE_EDIT_PROMOTIONAL_BOXES_SECTION_POPUP,
    };
}

export function setPagePreview(pageId, preview) {
    return {
        type: SET_PAGE_PREVIEW,
        payload: {
            pageId: pageId,
            preview: preview,
        },
    };
}

export function updateTextSectionContents(
    pageId,
    sectionId,
    data,
    sectionSettings,
    imageSettings,
    videoSettings
) {
    return {
        type: DONE_EDIT_TEXT_SECTION_POPUP,
        payload: {
            pageId,
            sectionId,
            data,
            sectionSettings,
            imageSettings,
            videoSettings,
        },
    };
}

export function updateTextColumnSingleMediaSectionContents(
    pageId,
    sectionId,
    data,
    imageSettings,
    videoSettings,
    sectionSettings,
) {
    return {
        type: DONE_EDIT_TEXT_SECTION_COLUMNS_SINGLE_MEDIA_POPUP,
        payload: {
            pageId,
            sectionId,
            data,
            imageSettings,
            videoSettings,
            sectionSettings,
        },
    };
}

export function updateOverviewSectionContents(
    pageId,
    sectionId,
    data,
    settings,
    includedFeatures,
    notIncludedFeatures
) {
    return {
        type: DONE_EDIT_OVERVIEW_SECTION_POPUP,
        payload: {
            pageId: pageId,
            sectionId: sectionId,
            data: data,
            settings: settings,
            includedFeatures: includedFeatures,
            notIncludedFeatures: notIncludedFeatures,
        },
    };
}

export function updateStaffSectionContents(pageId, sectionId, data, settings) {
    return {
        type: DONE_EDIT_STAFF_SECTION_POPUP,
        payload: {
            pageId: pageId,
            sectionId: sectionId,
            data: data,
            settings: settings,
        },
    };
}

export function updateReviewsSectionContents(
    pageId,
    sectionId,
    data,
    settings
) {
    return {
        type: DONE_EDIT_REVIEWS_SECTION_POPUP,
        payload: {
            pageId: pageId,
            sectionId: sectionId,
            data: data,
            settings: settings,
        },
    };
}

export function updateItinerarySectionContents(
    pageId,
    sectionId,
    data,
    settings
) {
    return {
        type: DONE_EDIT_ITINERARY_SECTION_POPUP,
        payload: {
            pageId: pageId,
            sectionId: sectionId,
            data: data,
            settings: settings,
        },
    };
}

export function updatePageMapSection(pageId, sectionId, data, settings, sectionSettings) {
    return {
        type: DONE_EDIT_MAP_SECTION_POPUP,
        payload: {
            pageId,
            sectionId,
            data,
            settings,
            sectionSettings,
        },
    };
}

export function updatePartnersSectionContents(
    pageId,
    sectionId,
    data,
    settings
) {
    return {
        type: DONE_EDIT_PARTNERS_SECTION_POPUP,
        payload: {
            pageId: pageId,
            sectionId: sectionId,
            data: data,
            settings: settings,
        },
    };
}

export function updateBlockSectionContents(
    block,
    pageId,
    sectionId,
    data,
    settings,
    sectionSettings
) {
    return {
        type: DONE_EDIT_BLOCK_SECTION_POPUP,
        payload: {
            block: block,
            pageId: pageId,
            sectionId: sectionId,
            data: data,
            settings: settings,
            sectionSettings,
        },
    };
}

export function updateFormSectionContents(pageId, sectionId, data, settings) {
    return {
        type: DONE_EDIT_FORM_SECTION_POPUP,
        payload: {
            pageId: pageId,
            sectionId: sectionId,
            data: data,
            settings: settings,
        },
    };
}

export function updateTripFormatsSectionContents(
    pageId,
    sectionId,
    data,
    settings
) {
    return {
        type: DONE_EDIT_TRIP_FORMATS_SECTION_POPUP,
        payload: {
            pageId: pageId,
            sectionId: sectionId,
            data: data,
            settings: settings,
        },
    };
}

export function updateProductSnippetsSectionContents(
    pageId,
    sectionId,
    data,
    settings
) {
    return {
        type: DONE_EDIT_PRODUCT_SNIPPETS_SECTION_POPUP,
        payload: {
            pageId: pageId,
            sectionId: sectionId,
            data: data,
            settings: settings,
        },
    };
}

export function updateInternalLinksSectionContents(
    pageId,
    sectionId,
    data,
    settings
) {
    return {
        type: DONE_EDIT_INTERNAL_LINKS_SECTION_POPUP,
        payload: {
            pageId: pageId,
            sectionId: sectionId,
            data: data,
            settings: settings,
        },
    };
}

export function updateCallToActionSectionContents(
    pageId,
    sectionId,
    data,
    settings
) {
    return {
        type: DONE_EDIT_CALL_TO_ACTION_SECTION_POPUP,
        payload: {
            pageId: pageId,
            sectionId: sectionId,
            data: data,
            settings: settings,
        },
    };
}

export function updateNextStepsSectionContents(
    pageId,
    sectionId,
    data,
    settings
) {
    return {
        type: DONE_EDIT_NEXT_STEPS_SECTION_POPUP,
        payload: {
            pageId: pageId,
            sectionId: sectionId,
            data: data,
            settings: settings,
        },
    };
}

export function updateReviewSnippetsSectionContents(
    pageId,
    sectionId,
    data,
    settings
) {
    return {
        type: DONE_EDIT_REVIEW_SNIPPETS_SECTION_POPUP,
        payload: {
            pageId: pageId,
            sectionId: sectionId,
            data: data,
            settings: settings,
        },
    };
}

export function updateFaqsSectionContents(pageId, sectionId, data, settings) {
    return {
        type: DONE_EDIT_FAQS_SECTION_POPUP,
        payload: {
            pageId: pageId,
            sectionId: sectionId,
            data: data,
            settings: settings,
        },
    };
}

export function updateEditFindYourProjectSection(pageId, sectionId, data) {
    return {
        type: DONE_EDIT_FIND_YOUR_PROJECT_SECTION_POPUP,
        payload: {
            pageId: pageId,
            sectionId: sectionId,
            data: data,
        },
    };
}

export function updateEditLargeSnippetsSection(pageId, sectionId, data) {
    return {
        type: DONE_EDIT_LARGE_SNIPPETS_SECTION_POPUP,
        payload: {
            pageId: pageId,
            sectionId: sectionId,
            data: data,
        },
    };
}

export function updateEditValuePropositionSection(pageId, sectionId, data) {
    return {
        type: DONE_EDIT_VALUE_PROPOSITION_SECTION_POPUP,
        payload: {
            pageId: pageId,
            sectionId: sectionId,
            data: data,
        },
    };
}

export function updateEditMeetUsSection(pageId, sectionId, data) {
    return {
        type: DONE_EDIT_MEET_US_SECTION_POPUP,
        payload: {
            pageId: pageId,
            sectionId: sectionId,
            data: data,
        },
    };
}

export function updateEditTripFormatsCarouselSection(pageId, sectionId, data) {
    return {
        type: DONE_EDIT_TRIP_FORMATS_CAROUSEL_SECTION_POPUP,
        payload: {
            pageId: pageId,
            sectionId: sectionId,
            data: data,
        },
    };
}

export function updateEditGroupTripsBannerSection(pageId, sectionId, data) {
    return {
        type: DONE_EDIT_GROUP_TRIPS_BANNER_SECTION_POPUP,
        payload: {
            pageId: pageId,
            sectionId: sectionId,
            data: data,
        },
    };
}

export function updateEditPromotionalBoxesSection(pageId, sectionId, data) {
    return {
        type: DONE_EDIT_PROMOTIONAL_BOXES_SECTION_POPUP,
        payload: {
            pageId,
            sectionId,
            data,
        },
    };
}

export function deleteSection(pageId, sectionId) {
    return {
        type: DELETE_SECTION_IN_PAGE_STATE,
        payload: {
            pageId,
            sectionId,
        },
    };
}

export function updateSectionGroup(pageId, sectionId, group) {
    return {
        type: UPDATE_SECTION_GROUP_IN_PAGE_STATE,
        payload: {
            pageId: pageId,
            sectionId: sectionId,
            group: group,
        },
    };
}

export function disableSection(pageId, sectionId) {
    return {
        type: DISABLE_SECTION_IN_PAGE_STATE,
        payload: {
            pageId: pageId,
            sectionId: sectionId,
        },
    };
}

export function enableSection(pageId, sectionId) {
    return {
        type: ENABLE_SECTION_IN_PAGE_STATE,
        payload: {
            pageId: pageId,
            sectionId: sectionId,
        },
    };
}

export function pickParentPage(pageId, parentPageId, parentPageTitle) {
    return {
        type: PICK_PARENT_PAGE,
        payload: {
            pageId: pageId,
            parentPageId: parentPageId,
            parentPageTitle: parentPageTitle,
        },
    };
}

export function updatePageMetaSection(pageId, meta, sectionLocations) {
    return {
        type: DONE_EDIT_META_SECTION_POPUP,
        payload: {
            pageId: pageId,
            meta: meta,
            sectionLocations: sectionLocations,
        },
    };
}

export function validatedUrl(url, pageId) {
    return {
        type: DONE_EDIT_URL_POPUP,
        payload: {
            url: url,
            pageId: pageId,
        },
    };
}

export function invalidateUrl(url, pageId) {
    return {
        type: INVALIDATE_URL_IN_THE_URL_EDIT_POPUP,
        payload: {
            url: url,
            pageId: pageId,
        },
    };
}

export function updateNewUrl(newUrl) {
    return {
        type: UPDATE_NEW_URL_IN_THE_URL_EDIT_POPUP,
        payload: {
            newUrl,
        },
    };
}

export function updateNoIndex(noindex, pageId) {
    return {
        type: UPDATE_NO_INDEX_IN_THE_URL_EDIT_POPUP,
        payload: {
            noindex,
            pageId,
        },
    };
}

export function openEditUrlPopup(url) {
    return {
        type: OPEN_URL_EDIT_POPUP,
        payload: {
            url,
        },
    };
}

export function closeEditUrlPopup() {
    return {
        type: CLOSE_URL_EDIT_POPUP,
    };
}

export function openEditProductTagosIdPopup(productTagosId) {
    return {
        type: OPEN_PRODUCT_TAGOS_ID_EDIT_POPUP,
        payload: {
            productTagosId,
        },
    };
}

export function updateProductTagosId(newProductTagosId) {
    return {
        type: UPDATE_PRODUCT_TAGOS_ID_EDIT_POPUP,
        payload: {
            newProductTagosId,
        },
    };
}

export function closeEditProductTagosIdPopup() {
    return {
        type: CLOSE_PRODUCT_TAGOS_ID_EDIT_POPUP,
    };
}

export function doneEditProductTagosId(productTagosId, pageId) {
    return {
        type: DONE_EDIT_PRODUCT_TAGOS_ID_POPUP,
        payload: {
            productTagosId: productTagosId,
            pageId: pageId,
        },
    };
}

export function openEditPageTagsPopup(existentPageTags) {
    return {
        type: OPEN_PAGE_TAGS_EDIT_POPUP,
        payload: {
            existentPageTags,
        },
    };
}

export function updatePageTags(singlePageTags, tagsKey, pageId) {
    singlePageTags =
        singlePageTags instanceof Array ? singlePageTags : [singlePageTags];

    return {
        type: UPDATE_PAGE_TAGS_EDIT_POPUP,
        payload: {
            singlePageTags: singlePageTags,
            tagsKey: tagsKey,
            pageId: pageId,
        },
    };
}

export function onMultipleTagsUpdate(multiplePageTags, tagsKey, pageId) {
    return {
        type: UPDATE_MULTIPLE_PAGE_TAGS,
        payload: {
            multiplePageTags: multiplePageTags,
            tagsKey: tagsKey,
            pageId: pageId,
        },
    };
}

export function closeEditPageTagsPopup(pageId) {
    return {
        type: CLOSE_PAGE_TAGS_EDIT_POPUP,
        pageId,
    };
}

export function doneEditPageTags(pageId) {
    return {
        type: DONE_EDIT_PAGE_TAGS_POPUP,
        payload: {
            pageId: pageId,
        },
    };
}

export function fetchedFormTypes(formTypes) {
    return {
        type: FETCHED_FORM_TYPES,
        formTypes,
    };
}

export function fetchedPageVersions(pageVersions) {
    return {
        type: FETCHED_PAGE_VERSIONS,
        pageVersions,
    };
}

export function fetchedPageVersion(pageVersion) {
    return {
        type: FETCHED_PAGE_VERSION,
        pageVersion,
    };
}

export function deletedPageVersion(versionId) {
    return {
        type: DELETED_PAGE_VERSION,
        versionId,
    };
}

export function updatedPageVersion(pageVersion) {
    return {
        type: UPDATED_PAGE_VERSION,
        pageVersion,
    };
}

export function openPagePicker() {
    return {
        type: OPEN_PAGE_PICKER,
    };
}

export function closePagePicker() {
    return {
        type: CLOSE_PAGE_PICKER,
    };
}

export function changeSectionBgColor(sectionBgColorId, sectionId, pageId) {
    return {
        type: CHANGE_SECTION_BG_COLOR,
        payload: {
            pageId,
            sectionId,
            sectionBgColorId,
        },
    };
}

export function setBgColors(bgColors) {
    return {
        type: SET_BG_COLORS,
        payload: {
            bgColors,
        },
    };
}

export function updateSection(pageId, sectionId, data, options = null) {
    return {
        type: UPDATE_SECTION,
        payload: {
            pageId,
            sectionId,
            data,
            block: options && options.block,
            locations: options && options.locations,
            settings: options && options.settings,
            imageSettings: options && options.imageSettings,
            videoSettings: options && options.videoSettings,
            sectionSettings: options && options.sectionSettings,
        },
    };
}

export function toggleSectionPopup(isOpen) {
    return {
        type: TOGGLE_SECTION_POPUP,
        payload: {
            isOpen,
        },
    };
}



// WEBPACK FOOTER //
// ./src/containers/builder/actions.js